import _ from "lodash";
import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

class VleRestClient extends RestClient {
  handleSpecialSnakeCase(data) {
    const mapping = {
      flow1: "flow_1",
      flow2: "flow_2",
      flow3: "flow_3",
      flow4: "flow_4",
      flow_unit1: "flow_unit_1",
      flow_unit2: "flow_unit_2",
      flow_unit3: "flow_unit_3",
      flow_unit4: "flow_unit_4",
      flow_ton_produced1: "flow_ton_produced_1",
      flow_ton_produced2: "flow_ton_produced_2",
      flow_ton_produced3: "flow_ton_produced_3",
      flow_ton_produced4: "flow_ton_produced_4",
    };
    return _.mapKeys(data, (value, key) => _.get(mapping, key, key));
  }
}

export const vleRestClient = new VleRestClient(atmoClient, "vles");
